import { LAYOUTS, } from '@voltmoney/types';
import { WIDGET, } from '@voltmoney/schema';
import { ROUTE } from '../../routes';
import { ACTION } from './type';
import { handleCloseOtpModalAction, handleTextChangeOtpAction, initAction, navNextToStepper, onLoad, verifyAction } from './actions';
import { getContactUsDetails } from '../../configs/utils';
export const template = (height, contactUsDetails, showEndJourney = false) => {
    return {
        layout: {
            id: ROUTE.MFD_SHARE_LINK_INIT,
            type: LAYOUTS.LIST,
            style: {
                isPartnerPlatform: true
            },
            widgets: [
                {
                    id: 'mfdShareLinkPage', type: WIDGET.MFD_SHARE_LINK_INIT_PAGE,
                },
            ],
        },
        datastore: {
            mfdShareLinkPage: {
                height,
                contactUsDetails,
                initAction: {
                    routeId: ROUTE.MFD_SHARE_LINK_INIT,
                    type: ACTION.INIT,
                    payload: {}
                },
                verifyAction: {
                    routeId: ROUTE.MFD_SHARE_LINK_INIT,
                    type: ACTION.VERIFY,
                    payload: {}
                },
                handleCloseOtpModalAction: {
                    routeId: ROUTE.MFD_SHARE_LINK_INIT,
                    type: ACTION.CLOSE_MODAL,
                    payload: {}
                },
                handleTextChangeOtpAction: {
                    routeId: ROUTE.MFD_SHARE_LINK_INIT,
                    type: ACTION.TEXT_CHANGE,
                    payload: {}
                },
                navNextToStepper: {
                    routeId: ROUTE.MFD_SHARE_LINK_INIT,
                    type: ACTION.NAV_TO_STEPPER,
                    payload: {}
                },
                showEndJourney: showEndJourney
            }
        },
    };
};
export const mfdShareLinkInitMf = {
    onLoad: async (_, { showEndJourney }) => {
        const contactUsDetails = await getContactUsDetails();
        setTimeout(async () => {
            !showEndJourney &&
                await onLoad({ standardUtilities: _ });
        }, 0);
        return Promise.resolve(template(_.getHeight(), contactUsDetails, showEndJourney));
    },
    // action: {
    //     type: ACTION.ONLOAD,
    //     routeId: ROUTE.MFD_SHARE_LINK_INIT,
    //     payload: {}
    // },
    actions: {
        // [ACTION.ONLOAD]: onLoad,
        [ACTION.INIT]: initAction,
        [ACTION.VERIFY]: verifyAction,
        [ACTION.CLOSE_MODAL]: handleCloseOtpModalAction,
        [ACTION.TEXT_CHANGE]: handleTextChangeOtpAction,
        [ACTION.NAV_TO_STEPPER]: navNextToStepper
    },
};
